// @flow
//eslint-disable-next-line

import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import {
	AppWrapper,
	Breadcrumb,
	ProceedToCheckout,
	ProductWidget,
	PaymentSummary,
} from '../../containers'
import {
	ARRAY_ROUTE_CONSTANTS,
	ANALYTICS_HELPER,
	HELPER,
	HISTORY,
	LANG_FORMAT,
	CART_HELPER,
	CONSTANTS,
	ROUTE_CONSTANTS,
} from '../../utils'
import { useTranslation } from '../../hooks'

function CartForm() {
	const translate = useTranslation()

	const { count } = useSelector((state) => state.cart.cart_items)
	const { cart_items } = useSelector((state) => state.cart)
	const { catalog_cart_items } = useSelector((state) => state.config.catalog_journey_settings)
	const { allProducts } = useSelector((state) => state.inventory)

	useEffect(() => {
		ANALYTICS_HELPER._screenShift(ANALYTICS_HELPER.EVENT_STEPS.CART, ANALYTICS_HELPER.CATEGORY.CART)
	}, [])

	useEffect(() => {
		/*
      UPDATE CART ITEMS
    */
		if (
			Object.keys(catalog_cart_items).length === 0 &&
			parseInt(cart_items.count) === 0 &&
			parseInt(cart_items?.sub_total_amount) === 0 &&
			ARRAY_ROUTE_CONSTANTS.includes(HISTORY.location.pathname)
		) {
			if (!HELPER.isEmpty(allProducts)) {
				HISTORY.goBack()
			} else {
				HISTORY.push(ROUTE_CONSTANTS.BASE)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [cart_items])

	let MESSAGE_OPTIONS = {
		item_name: count,
	}

	return (
		<AppWrapper
			showBackIcon={false}
			observeBackHistory={true}
			showLangIcon={true}
			showCartIcon={false}
			showAccountDropdown={true}
			showFooter={CART_HELPER.CART_DEVICE_TYPE() === CONSTANTS.DEVICE_TYPE.WEB ? true : false}
		>
			<Breadcrumb
				options={{
					headerClass: '',
					title: translate('BREADCRUMB.CART'),
				}}
			/>
			<div className="catalogContentWrap">
				<div className={`custom-animate`}>
					<div className="yourBagContainer">
						<div className="container my-cont">
							<div className="row">
								<div className="col-md-12 mainTabWraper">
									<div id="yourBagTab">
										<div className="row">
											<div className="col-md-8 col-sm-10 yourBagLeftSide cartContent">
												<h4 className="bag-heading">
													{LANG_FORMAT.FORMAT_CART_SUMMARY_MSG(
														translate('CART.GENERAL_BTNS.CART_SUMMARY', MESSAGE_OPTIONS),
														MESSAGE_OPTIONS.item_name
													)}
												</h4>
												<div className="detailed-prod">
													<ProductWidget />
												</div>
											</div>
											<div className="col-md-4 col-sm-10 yourBagRightSide">
												<PaymentSummary />
												<div className="proceedToCheckoutStep">
													<ProceedToCheckout />
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</AppWrapper>
	)
}

export default CartForm
